<p-toast
  [showTransformOptions]="'translateY(100%)'"
  [showTransformOptions]="'translateX(100%)'"
  [showTransitionOptions]="'500ms'"
  [hideTransitionOptions]="'1000ms'"
  (onClose)="onToastClose()">
  <ng-template
    let-message
    pTemplate="headless">
    <div class="flex flex-row toast-container {{ getBgGradientClass }}">
      <div class="">
        <div class="color-indicator {{ getBgColorClass }}"></div>
      </div>
      <div class="content-center mx-4">
        <span class="inline-block h-6 w-6 text-white rounded-full {{ getBgColorClass }}"
          ><i class="pi pi-info ml-1.5"></i
        ></span>
      </div>
      <div class="basis-10/12 content-center font-app-regular text-darkest">{{ message.detail }}</div>
      <div class="basis-1/12 content-center">
        <p-button
          type="button"
          class="text-darkest"
          size="small"
          icon="pi pi-times"
          (onClick)="closeToast()" />
      </div>
    </div>
  </ng-template>
</p-toast>

